// @ts-nocheck
// @ts-strict-ignore
export const whitelist = (data, steps) => {
  const fieldsToTrack = steps.reduce((fields, step) => {
    return fields.concat(step.fields.filter((f) => f.trackInput).map((f) => f.name))
  }, [])

  return Object.entries(data).reduce((obj, [key, value]) => {
    return { [key]: fieldsToTrack.includes(key) ? value : 'untracked', ...obj }
  }, {})
}

export const trackFields = (fields) => {
  return fields.filter((field) => field.gtmTrackingEnabled).map((field) => field.name)
}
